module.exports = {
  APPLICATION_ID: "nQYeipThuQF2g7afy9hhHfXAs5l8Ahvc1qTNn5or",
  JAVASCRIPT_KEY: "NRwbmKkiooyHx0v3VE23nYrkPhr2RqjXwQlI7L6d",
  SERVER_URL: "https://parseapi.back4app.com/",
  LIVE_SERVER_URL: "wss://modernwebdevproject.b4a.io",
};
